import { getMoment } from "../../utils/helper";
import {
  contactResultOptions,
  reasonOptions,
  REASON_REQUIRED_RESULTS,
} from "../../views/pages/pos/components/MemberProfilePopup/components/contact-history/constants";

export const CARD_WIDTH = 400;
export const CARD_HEIGHT = 480;
export const MINIMIZED_WIDTH = 220;
export const MINIMIZED_HEIGHT = 44;

export { contactResultOptions, reasonOptions, REASON_REQUIRED_RESULTS };

export const APPOINTMENT_STATUS = {
  WAITING: "Waiting",
  COMPLETE: "Complete",
  CANCEL: "Cancel",
};

export const DEFAULT_CONTACT_STATUS = undefined;

export const formatDate = (dateVal) => getMoment(dateVal, "DD-MM-YYYY, HH:mm");

export const RESULT_STYLE_MAP = {
  "สั่งซื้อ": { color: "#389e0d", bg: "#f6ffed", border: "#b7eb8f" },
  "สั่งจอง": { color: "#08979c", bg: "#e6fffb", border: "#87e8de" },
  "ลูกค้านัดติดต่อใหม่/ยังไม่สะดวกคุย": { color: "#d48806", bg: "#fffbe6", border: "#ffe58f" },
  "ลูกค้าให้นัดติดต่อกลับ/ยังไม่สะดวกคุย": { color: "#d48806", bg: "#fffbe6", border: "#ffe58f" },
  "ไม่สนใจ_(ระบุสาเหตุ)": { color: "#d4380d", bg: "#fff2e8", border: "#ffbb96" },
  "ไม่รับสาย/ปิดเครื่อง/ติดต่อไม่ได้": { color: "#595959", bg: "#f5f5f5", border: "#d9d9d9" },
  "ไม่รับสายครบ 3 ครั้ง": { color: "#cf1322", bg: "#fff1f0", border: "#ffa39e" },
  "Complain case": { color: "#531dab", bg: "#f9f0ff", border: "#d3adf7" },
  "Lead ซ้ำ": { color: "#096dd9", bg: "#e6f7ff", border: "#91d5ff" },
  "Backlist": { color: "#ffffff", bg: "#262626", border: "#262626" },
  "เบอร์ผิด/เสีย/ตปท.": { color: "#d46b08", bg: "#fff7e6", border: "#ffd591" },
  "เบอร์ผิด/เสีย/สลับ": { color: "#d46b08", bg: "#fff7e6", border: "#ffd591" },
  "ไม่สนใจ_ห้ามติดต่ออีก(ระบุสาเหตุ)": { color: "#c41d7f", bg: "#fff0f6", border: "#ffadd2" },
  "สั่งซื้อช่องทางอื่นแล้ว": { color: "#1d39c4", bg: "#f0f5ff", border: "#adc6ff" },
  "ติดต่อไม่ได้ รอการ Follow Up อีกครั้ง": { color: "#d48806", bg: "#fffbe6", border: "#ffe58f" },
  "Follow Up_Unsuccess_ติดต่อไม่ได้": { color: "#595959", bg: "#f5f5f5", border: "#d9d9d9" },
  "สอบถามทั่วไป": { color: "#096dd9", bg: "#e6f7ff", border: "#91d5ff" },
};

export const getStatusStyle = (statusVal) => {
  return RESULT_STYLE_MAP[statusVal] || { color: "#1890ff", bg: "#e6f7ff", border: "#91d5ff" };
};



export const thLocale = {
  lang: {
    placeholder: "เลือกวันที่",
    rangePlaceholder: ["วันเริ่มต้น", "วันสิ้นสุด"],
    today: "วันนี้",
    now: "ตอนนี้",
    backToToday: "กลับไปยังวันนี้",
    ok: "ตกลง",
    clear: "ล้างข้อมูล",
    month: "เดือน",
    year: "ปี",
    timeSelect: "เลือกเวลา",
    dateSelect: "เลือกวันที่",
    monthSelect: "เลือกเดือน",
    yearSelect: "เลือกปี",
    decadeSelect: "เลือกทศวรรษ",
    yearFormat: "YYYY",
    dateFormat: "D/M/YYYY",
    dayFormat: "D",
    dateTimeFormat: "D/M/YYYY HH:mm:ss",
    monthBeforeYear: true,
    previousMonth: "เดือนก่อนหน้า (PageUp)",
    nextMonth: "เดือนถัดไป (PageDown)",
    previousYear: "ปีก่อนหน้า (Control + left)",
    nextYear: "ปีถัดไป (Control + right)",
    previousDecade: "ทศวรรษก่อนหน้า",
    nextDecade: "ทศวรรษถัดไป",
    previousCentury: "ศตวรรษก่อนหน้า",
    nextCentury: "ศตวรรษถัดไป",
  },
  timePickerLocale: {
    placeholder: "เลือกเวลา",
  },
};
